import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import apiConfig from '../axiosConfig';

export const getBulkPurchaseDetails = createAsyncThunk(
	'bulkPurchase/get',
	async ({ bulkPurchaseId }) => {
		const response = await apiConfig
		.get(`/bulk-purchase/getBulkPurchase/${bulkPurchaseId}`)
		.then((response) => response)
			.catch((error) => error);
		return response.data;
	}
);

export const getAllVouchersByBulkPurchaseId = createAsyncThunk(
	'bulkPurchase/vouchers/get',
	async ({ bulkPurchaseId, searchValue, pageNumber, pageSize}) => {
		let queryParam = '';
		if(searchValue != null && searchValue != ''){
			queryParam = `?code=${searchValue}`
		}
		const response = await apiConfig
			.get(`/bulk-purchase/getVouchers/${bulkPurchaseId}/${pageNumber+1}/${pageSize}${queryParam}`)
			.then((response) => response)
			.catch((error) => error);

		return response.data;
	}
);

const bulkPurchaseListVouchersSlice = createSlice({
	name: 'bulkPurchaseListVouchers',
	initialState: {
		vouchers: [],
		bulkPurchaseDetails: []
	},
	reducers: {},
	extraReducers: {
		[getAllVouchersByBulkPurchaseId.fulfilled]: (state, action) => {
			const response = action.payload;
			const data = response && response.data ? response.data : [];
			state.vouchers = data;
		},
		[getBulkPurchaseDetails.fulfilled]: (state, action) => {
			const response = action.payload;
			const data = response && response.data ? response.data : [];
			state.bulkPurchaseDetails = data;
		}
	},
});

export const assetManagementActions = bulkPurchaseListVouchersSlice.actions;
export default bulkPurchaseListVouchersSlice.reducer;